import { useId } from "react";
import { useFormContext } from "react-hook-form";
import type { FirstLocationFormValues } from "../_helpers/createClientForm";
import { AddressFormFields } from "./AddressFormFields";
import { FormField, INPUT_CLASS } from "./FormField";

// The New Client drawer's first location, when it is not the organization's:
// its name and address. It renders inside a FormProvider of its own over
// FirstLocationFormValues: AddressFormFields registers fixed field names, which
// the organization's address already holds in the drawer's main form.
export const FirstLocationFields = () => {
    const {
        register,
        formState: { errors },
    } = useFormContext<FirstLocationFormValues>();
    const nameId = useId();

    return (
        <div className="flex flex-col gap-4">
            <FormField
                id={nameId}
                label="Location Name"
                error={errors.locationName?.message}
            >
                <input
                    id={nameId}
                    type="text"
                    className={INPUT_CLASS}
                    {...register("locationName")}
                />
            </FormField>
            <AddressFormFields />
        </div>
    );
};
